export default __webpack_public_path__ + "static/media/walletWhite.7e108f54.svg";